import React from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import useCreatePayment from "../../controllers/useCreatePayment";
import InputField from "../components/InputField";
import ErrorMessage from "../components/errorMessage";
import { DatePicker } from "antd";
import { Calendar } from "feather-icons-react/build/IconComponents";

const Createpayment = ({ customer, refetch }) => {
  console.log("customer", customer);
  const { values, functions } = useCreatePayment(customer, refetch);

  const paymenttype = [
    { value: "Cash", label: "Cash" },
    { value: "Cheque", label: "Cheque" },
    { value: "Wire", label: "Wire" },
  ];

  return (
    <div>
      <div
        className="modal fade"
        id="createpayment"
        tabIndex={-1}
        aria-labelledby="createpayment"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 custom-modal-header">
              <div className="page-title">
                <h4>Create Payments</h4>
              </div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={functions.onCancel}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body custom-modal-body">
              <form>
                <div className="row"></div>
                <div className="row">
                  <div className="col-lg-12 col-sm-12 col-12">
                    <div className="input-blocks">
                      <label className="form-label">
                        Payment Type <span className="text-danger">*</span>
                      </label>
                      <Controller
                        name="paying_type"
                        control={values.control}
                        rules={{ required: "Payment Type is required" }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            classNamePrefix="react-select"
                            className="mb-2"
                            options={paymenttype}
                            placeholder="Select Payment Type"
                            value={field.value}
                            // value={values?.paying_type?.find(
                            //   (option) => option.value === field.value
                            // )}
                            onChange={(selectedOption) =>
                              field.onChange(selectedOption)
                            }
                          />
                        )}
                      />
                      <ErrorMessage
                        error={values?.errors?.paying_type?.message}
                      />
                    </div>
                  </div>
                  {customer?.walk_in == true && (
                    <div className="col-lg-6 col-sm-6 col-12">
                      <div className="mb-3 add-product">
                        <label className="form-label">Invoice Number</label>
                        <Controller
                          name="sale_id"
                          control={values.control}
                          render={({ field }) => {
                            {
                              console.log("field", field);
                            }
                            return (
                              <Select
                                {...field}
                                classNamePrefix="react-select"
                                className="mb-2"
                                options={values.salesList}
                                placeholder="Select Invoice Number"
                                value={field.value}
                                onChange={(selectedOption) =>
                                  field.onChange(selectedOption)
                                }
                              />
                            );
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {/* <div className="col-lg-4 col-sm-12 col-12">
                    <div className="input-blocks">
                      <label>Paying Amount</label>
                      <div className="input-groupicon calender-input">
                        <i data-feather="dollar-sign" className="info-img" />
                        <input type="text" />
                      </div>
                    </div>
                  </div> */}
                  <div className="col-lg-6 col-sm-12 col-12">
                    <div className="input-blocks">
                      <label>
                        Payment Date <span> *</span>
                      </label>
                      <div className="input-groupicon calender-input mb-2">
                        <Calendar className="info-img" />
                        <Controller
                          name="payment_date"
                          control={values.control}
                          rules={{ required: "Payment Date is required" }}
                          render={({ field }) => (
                            <DatePicker
                              {...field}
                              required={true}
                              name="payment_date"
                              onChange={(date) => {
                                field.onChange(date);
                              }}
                              type="date"
                              className="filterdatepicker"
                              dateFormat="dd-MM-yyyy"
                              placeholder="Enter Payment Date"
                            />
                          )}
                        />
                      </div>
                      <ErrorMessage
                        error={values.errors.payment_date?.message}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6 col-sm-12 col-12">
                    <div className="input-blocks">
                      <Controller
                        name="received_amount"
                        rules={{ required: "Received Amount is required" }}
                        control={values.control}
                        render={({ field }) => (
                          <InputField
                            label="Received Amount"
                            isDisable={customer?.walk_in}
                            type="number"
                            required
                            placeholder="Enter Received Amount"
                            {...field}
                          />
                        )}
                      />
                      <ErrorMessage
                        error={values?.errors?.received_amount?.message}
                      />
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="input-blocks">
                      <Controller
                        name="description"
                        // rules={{ required: "Description is required" }}
                        control={values.control}
                        render={({ field }) => (
                          <InputField
                            label="Description"
                            type="textarea"
                            // required
                            placeholder="Enter Description"
                            {...field}
                          />
                        )}
                      />
                      <p>Maximum 60 Characters</p>
                      <ErrorMessage
                        error={values?.errors?.description?.message}
                      />
                      {/* <label>Description</label>
                      <textarea className="form-control" defaultValue={""} />
                      <p>Maximum 60 Characters</p> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="modal-footer-btn">
                    <button
                      type="button"
                      className="btn btn-cancel me-2"
                      data-bs-dismiss="modal"
                      onClick={functions.onCancel}
                    >
                      Cancel
                    </button>
                    <Link
                      onClick={functions.onSubmit}
                      to="#"
                      className="btn btn-submit"
                    >
                      Submit
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Createpayment.propTypes = {
  customer: PropTypes.any,
  refetch: PropTypes.func,
};

export default Createpayment;
